import Icon from "../../../general/Icon/Icon";
import type { FC } from "react";

import * as s from "./ComparisonItem.module.scss";
import { cn } from "@babybjorn/ui";

type ComparisonContentProps = {
	uid: string;
	label: string;
	value: string | boolean;
};

export type ComparisonItemProps = {
	uid: string;
	image: { alt: string | null; src: string | null } | undefined | null;
	productName: string;
	content: ComparisonContentProps[];
	readMore: { label: string; link: string };
};

type ComparisonProps = {
	label: string;
	items: ComparisonItemProps[];
};

const ComparisonItem: FC<ComparisonProps> = ({ label, items }) => {
	return (
		<tr className={s.info}>
			<th>{label}</th>
			<td>
				{items.flatMap((i) =>
					i.content
						.filter((item) => item.label === label)
						.map((i) => <CompareValue key={i.uid} value={i.value} />),
				)}
			</td>
		</tr>
	);
};

export default ComparisonItem;

type CompareValueProps = { value: string | boolean };

const CompareValue: FC<CompareValueProps> = ({ value }) => {
	return typeof value === "boolean" ? (
		<span>
			<Icon
				icon={value ? "checkmark" : "close"}
				className={cn({ [s.icon]: !value })}
			/>
		</span>
	) : (
		<p>{value}</p>
	);
};
